import _ from "lodash";
import {
    FETCH_INVOICES_REQUEST_GAS,
    FETCH_INVOICES_FILTER_REQUEST_GAS,
    RECEIVE_INVOICES_GAS,
    RECEIVE_INVOICES_FILTER_GAS,
    EXPORT_INVOICE_REQUEST_GAS, EXPORT_INVOICE_DONE_GAS, MESSAGE_INVOICE_GAS,
    CLEAR_INVOICE_PAGINATION_GAS, SET_ITEMS_OFFSET_GAS, SET_FILTERS_GAS
} from '../../../constants/index'
import {
    data_fetch_api_resource,
    data_download_api_resource
} from '../../../utils/http_functions'
import {
    parseJSON
} from '../../../utils/misc'
import saveAs from 'file-saver';
import { i18n } from "../../../config";


export function fetchInvoicesRequest(initial) {
    const message = (initial)?null:i18n.t('common:text.invoices_updating_list');

    return {
        type: FETCH_INVOICES_REQUEST_GAS,
        payload: {
            message,
        },
    };
}

export function fetchInvoicesFilterRequest() {
  return {
    type: FETCH_INVOICES_FILTER_REQUEST_GAS
  };
}

export function receiveInvoices(response, initial, filters, errors=null) {
    const message = (initial)?null:i18n.t('common:text.invoices_updated_list');
    return {
        type: RECEIVE_INVOICES_GAS,
        payload: {
            response,
            message,
            filters,
            errors
        },
    };
}

export function receiveInvoicesFilter(payload) {
  return {
    type: RECEIVE_INVOICES_FILTER_GAS,
    payload
  };
}

export const messageInvoice = message => {
  return {
    type: MESSAGE_INVOICE_GAS,
    payload: {
      message
    }
  }
}

export function changeItemsOffset(newItemsOffset) {
  return {
    type: SET_ITEMS_OFFSET_GAS,
    payload: {
      itemsOffset: newItemsOffset
    }
  }
}

export function changeFilter(newFilters, newItemsPage, newItemsOffset) {
  return {
    type: SET_FILTERS_GAS,
    payload: {
      itemsPage: newItemsPage,
      itemsOffset: newItemsOffset,
      currentFilter: newFilters
    }
  }
}

export function clearPagination() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_INVOICE_PAGINATION_GAS
    });
  }
}

export function exportInvoiceRequest(invoice) {
  return {
    type: EXPORT_INVOICE_REQUEST_GAS,
    payload: {
      invoice,
      message: null,
    },
  };
}

export function exportInvoiceDone(invoice) {
  return {
    type: EXPORT_INVOICE_DONE_GAS,
    payload: {
      invoice
    },
  };
}

export function fetchFilters(token, type) {
  return (dispatch) => {
    dispatch(fetchInvoicesFilterRequest());

    const resource = `filter/params?fields=cups,addresses,contracts,vats&type=${type}`;

    data_fetch_api_resource(token, resource, 2)
    .then(parseJSON)
    .then((response) => {
      dispatch(receiveInvoicesFilter(response));
    })
    .catch(error => {
      dispatch(receiveInvoicesFilter({}));
      // if (error.status === 401) {
      //     dispatch(logoutAndRedirect(error));
      // }
    });
  }
}

export function fetchInvoices({token='', initial = false, filters = '', offset = 0, limit = 100}) {
  return (dispatch, getState) => {
    dispatch(fetchInvoicesRequest(initial));

    const resource = `invoices/?offset=${offset}&limit=${limit}&filter=[${filters}]`;

    data_fetch_api_resource(token, resource, 2)
      .then(parseJSON)
      .then((response) => {
        dispatch(receiveInvoices(response, initial, filters));
      })
      .catch((error) => {
        if (error.status === 401) {
          // dispatch(logoutAndRedirect(error));
        } else {
          dispatch(receiveInvoices([], initial, filters, error));
        }
      });
  };
}

export function exportInvoice(token, invoice, report_type) {
  return (dispatch) => {
    dispatch(exportInvoiceRequest(invoice));
    data_download_api_resource(token, `invoices/${ invoice }/${ report_type }/`, 2)
      .then(response => {
        const filename = response.headers["content-disposition"].split("=");
        dispatch(messageInvoice(i18n.t('common:text.invoices_download_ready')));
        saveAs(response.data, filename[1]);
      })
      .catch(error => {
        // if (error.status === 401) {
        //     dispatch(logoutAndRedirect(error));
        // }
      })
      .finally(() => {
        dispatch(exportInvoiceDone(invoice));
      });
  };
}
